// src/Pages/SplashScreen.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logoerlan.png";
import "../styles/SplashScreen.css";

const SplashScreen = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [currentText, setCurrentText] = useState("Iniciando sistema...");

  const loadingTexts = [
    "Iniciando sistema...",
    "Cargando módulos de seguridad...",
    "Conectando con servicios...",
    "Preparando interfaz...",
    "¡Listo para usar!"
  ];

  useEffect(() => {
    // Simular progreso de carga
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 2;
      });
    }, 80);

    // Cambiar textos durante la carga
    const textInterval = setInterval(() => {
      setCurrentText(prev => {
        const currentIndex = loadingTexts.indexOf(prev);
        const nextIndex = (currentIndex + 1) % loadingTexts.length;
        return loadingTexts[nextIndex];
      });
    }, 5000);

    // Navegar después de 5 segundos
    const navigationTimer = setTimeout(() => {
      navigate("/cifranegra", { replace: true });
    }, 5000);

    return () => {
      clearInterval(progressInterval);
      clearInterval(textInterval);
      clearTimeout(navigationTimer);
    };
  }, [navigate]);

  return (
    <div className="splash-container">
      <div className="splash-content">
        <img src={logo} alt="Logo Erlan" className="splash-logo" />
        
        <h1 className="splash-title">
          Sistema de Reporte de Tránsito Miraflores
        </h1>
        
        <p className="splash-subtitle">
          Tu seguridad es nuestra prioridad
        </p>

        <div className="splash-features">
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <span className="feature-text">Seguro</span>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-bolt"></i>
            </div>
            <span className="feature-text">Rápido</span>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon">
              <i className="fas fa-users"></i>
            </div>
            <span className="feature-text">Confiable</span>
          </div>
        </div>

        <div className="splash-animation">
          <div className="loading-bar-container">
            <div 
              className="loading-bar" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          
          <div className="loading-text">
            {currentText}
          </div>
          
          <div className="progress-percentage">
            {progress}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;